//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Address } from './misc-codegen';

export interface AllSupplierSettings {
    settings: SupplierSettings;
    purchaseOrderRecipients: PurchaseOrderRecipientLibrary;
    pricingRules: PricingRuleLibrary;
}

export interface ConnectedState {
    connected: boolean;
}

export interface ConnectedStateServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ConnectedState | null;
}

export interface InputCreateTerritory {
    territoryName: string;
}

export interface InputDeleteTerritory {
    id: string;
}

export interface InputGetCoreSupplierSettings {
}

export interface InputLinkFranchiseeBranchToTerritory {
    branchIds: string[];
    territoryId: string;
}

export interface InputUnlinkFranchiseeBranchFromTerritory {
    territoryFranchiseeBranchLinks: TerritoryFranchiseeBranchLink[];
}

export interface InputUpdateCoreSupplierSettings {
    settings: SupplierSettings;
    purchaseOrderRecipients: PurchaseOrderRecipientLibrary | null;
    pricingRules: PricingRuleLibrary | null;
    base64PositiveLogo: string | null;
    positiveLogoFileName: string | null;
    base64NegativeLogo: string | null;
    negativeLogoFileName: string | null;
    base64LoginImage: string | null;
    loginImageFileName: string | null;
    base64TermsAndConditions: string | null;
    base64TermsOfUse: string | null;
}

export interface InputUpdateTerritories {
    territories: Territory[];
}

export interface PricingRule {
    id: string;
    supplierId: number;
    name: string;
    ruleTypeId: string;
    minValue: number;
    maxValue: number;
    minMarkup: number;
    maxMarkup: number;
}

export interface PricingRuleLibrary {
    pricingRules: PricingRule[];
    pricingRuleTypes: PricingRuleType[];
    defaultPricingRuleId: string;
}

export interface PricingRuleType {
    id: string;
    name: string;
    hasMinMax: boolean;
}

export interface PurchaseOrderRecipient {
    id: string;
    email: string;
}

export interface PurchaseOrderRecipientLibrary {
    recipients: PurchaseOrderRecipient[];
}

export enum QuoteType {
    None = 0,
    Estimate = 1,
    Quote = 2,
    Display = 4,
    Warranty = 8,
}

export interface RequestGetTerritorySummary {
}

export interface RequestSystemConfiguration {
}

export interface ResultCreateTerritory {
    territory: Territory;
}

export interface ResultCreateTerritoryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateTerritory | null;
}

export interface ResultDeleteTerritory {
}

export interface ResultDeleteTerritoryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDeleteTerritory | null;
}

export interface ResultGetCoreSupplierSettings {
    allSettings: AllSupplierSettings;
}

export interface ResultGetCoreSupplierSettingsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetCoreSupplierSettings | null;
}

export interface ResultGetTerritorySummary {
    territories: Territory[];
    territoryFranchiseBranches: TerritoryFranchiseeBranchLink[];
}

export interface ResultGetTerritorySummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetTerritorySummary | null;
}

export interface ResultLinkFranchiseeBranchToTerritory {
    territoryFranchiseeBranchLinks: TerritoryFranchiseeBranchLink[];
}

export interface ResultLinkFranchiseeBranchToTerritoryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultLinkFranchiseeBranchToTerritory | null;
}

export interface ResultSystemConfiguration {
    supplierQuoteItemConfigurations: SupplierQuoteItemTableConfiguration[];
}

export interface ResultSystemConfigurationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultSystemConfiguration | null;
}

export interface ResultUnlinkFranchiseeBranchFromTerritory {
}

export interface ResultUnlinkFranchiseeBranchFromTerritoryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUnlinkFranchiseeBranchFromTerritory | null;
}

export interface ResultUpdateCoreSupplierSettings {
    settings: AllSupplierSettings;
}

export interface ResultUpdateCoreSupplierSettingsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateCoreSupplierSettings | null;
}

export interface ResultUpdateTerritories {
    territories: Territory[];
}

export interface ResultUpdateTerritoriesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateTerritories | null;
}

export interface ServiceResponseError {
    message: string;
    stackTrace: string | null;
}

export enum ServiceResponseType {
    None = 0,
    Ok = 1,
    NotFound = 2,
    UnAuthenticated = 4,
    UnAuthorized = 8,
    Error = 16,
    TransientDbError = 32,
    ValidationFailure = 64,
    ModifyNotFound = 128,
}

export interface SupplierQuoteItemTableConfiguration {
    code: string;
    title: string;
    systemDefault: boolean;
    defaultDisplay: boolean;
    canSwitch: boolean;
}

export interface SupplierSettings {
    lastModifiedUserId: string | null;
    lastModifiedUtc: string | null;
    rowVersion: string | null;
    id: string;
    globalSupplierId: number;
    positiveLogoVirtualPath: string;
    negativeLogoVirtualPath: string;
    loginImageVirtualPath: string;
    allowCustomItem: boolean;
    allowSupportRequest: boolean;
    allowSupplierReview: boolean;
    allowedQuoteTypes: QuoteType[];
    validityPeriod: number;
    leadPeriod: number;
    watermark: WatermarkType;
    termsAndConditionsVirtualPath: string;
    termsOfUseVirtualPath: string;
    purchaseOrderRecipientsVirtualPath: string;
    pricingRulesVirtualPath: string;
    willCallLocations: WillCallLocation[] | null;
    quoteItemTableConfiguration: SupplierTableConfig[] | null;
}

export interface SupplierTableConfig {
    code: string;
    title: string;
    systemDefault: boolean;
    defaultDisplay: boolean;
    canSwitch: boolean;
}

export interface WillCallLocation {
  id: string;
  title: string;
  type: string;
  willCallAddress: WillCallAddress;
}

export interface WillCallAddress extends Address {}

export interface Territory {
    dateCreated: string;
    id: string;
    recordVersion: string;
    name: string;
    supplierId: string;
}

export interface TerritoryFranchiseeBranchLink {
    dateCreated: string;
    id: string;
    recordVersion: string;
    territoryId: string;
    branchId: string;
}

export enum WatermarkType {
    DraftInternalRed = 0,
    DraftInternal = 1,
    InternalUse = 2,
    Draft = 4,
    DraftVersion = 8,
}